import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
  async getCCMAllergyByPatientId (patientId) {
    const response = await _axios.get(
      `/ccmallergy/getbypatientid/${patientId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM Allergy by patient ID');
  },
  async getCCMAllergyByCCMRecordId (ccmRecordId) {
    try {
      const response = await _axios.get(
        `/ccmallergy/getbyccmrecordid/${ccmRecordId}`,
      );
      if (response.data.resFlag) {
        return response.data;
      }
      throw new CCMError('Error getting CCM Allergy by CCM record ID');
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return [];
      }
      throw new CCMError('Error getting CCM Allergy by CCM record ID', error);
    }
  },
  async getCCMAllergy (id) {
    const response = await _axios.get(`/ccmallergy/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM Allergy');
  },
  async addCCMAllergy (body) {
    const response = await _axios.post('/ccmallergy', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error adding CCM Allergy');
  },
  async updateCCMAllergy (id, body) {
    const response = await _axios.put(`/ccmallergy/${id}`, body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error updating CCM Allergy');
  },
  async deleteCCMAllergy (id) {
    const response = await _axios.delete(`/ccmallergy/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting CCM Allergy');
  },
};
